export function getView(payment_plan, discount) {
  return payment_plan.insurances.length > 0 && !discount.is_applied_to_payor
}
